import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import GalleryRows from './GalleryRows';
import { Toaster } from 'sonner';

const NO_ZONE = ['/', '/admin', '/login', '/register', '/inbox', '/dashboard', '/gallery', '/claim-position'];

export default function Layout({ children }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
        {!NO_ZONE.includes(pathname) && (
          <GalleryRows key={pathname} scope={`zone:${pathname}`} wrapClass="bg-white py-12" innerClass="max-w-7xl mx-auto px-6" />
        )}
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}
